import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap'
import i18n from './i18n/index.js'
import './axios'
import 'hooper/dist/hooper.css';

const lang = localStorage.getItem('lang');
if (lang === 'en') {
	document.documentElement.setAttribute('dir', 'ltr');
} else {
	document.documentElement.setAttribute('dir', 'rtl');
}

Vue.config.productionTip = false

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')
